import { ProfileDetailTabType, ProfileDetailTabTypeString } from '@diritto/common/account/constants/profile.constant';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { Divider } from 'ui-components/common/Divider';
import { Link } from 'ui-components/common/Link';
import { numberComma } from '@diritto/common/utils/string';
import { ProfileDto } from '@diritto/common/account/dtos/profile.dto';

interface ProfileTabProps {
  className?: string;
  profile?: ProfileDto;
  tabType: ProfileDetailTabType;
  fancyShareCount?: number;
  contentCount?: number;
  replyCount?: number;
  rollingCount?: number;
}

export const ProfileTab = ({
  className,
  profile,
  tabType,
  fancyShareCount = 0,
  contentCount = 0,
  replyCount = 0,
  rollingCount = 0,
}: ProfileTabProps) => {
  if (!profile) {
    return null;
  }

  return (
    <StyledWrapper className={className}>
      <StyledListWrapper>
        {profile.isAuthor ? (
          <>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.Content}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.Content}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.Content]}&nbsp;
                {contentCount > 0 ? numberComma(contentCount) : undefined}
              </StyledListItem>
            </Link>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.Reply}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.Reply}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.Reply]}&nbsp;
                {replyCount > 0 ? numberComma(replyCount) : undefined}
              </StyledListItem>
            </Link>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.FancyShare}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.FancyShare}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.FancyShare]}&nbsp;
                {fancyShareCount > 0 ? numberComma(fancyShareCount) : undefined}
              </StyledListItem>
            </Link>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.Rolling}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.Rolling}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.Rolling]}&nbsp;
                {rollingCount > 0 ? numberComma(rollingCount) : undefined}
              </StyledListItem>
            </Link>
          </>
        ) : (
          <>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.FancyShare}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.FancyShare}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.FancyShare]}&nbsp;
                {fancyShareCount > 0 ? numberComma(fancyShareCount) : undefined}
              </StyledListItem>
            </Link>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.Rolling}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.Rolling}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.Rolling]}&nbsp;
                {rollingCount > 0 ? numberComma(rollingCount) : undefined}
              </StyledListItem>
            </Link>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.Reply}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.Reply}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.Reply]}&nbsp;
                {replyCount > 0 ? numberComma(replyCount) : undefined}
              </StyledListItem>
            </Link>
            <Link href={`/accounts/profiles/${profile.id}?tabType=${ProfileDetailTabType.Content}`} replace shallow>
              <StyledListItem isActive={tabType === ProfileDetailTabType.Content}>
                {ProfileDetailTabTypeString[ProfileDetailTabType.Content]}&nbsp;
                {contentCount > 0 ? numberComma(contentCount) : undefined}
              </StyledListItem>
            </Link>
          </>
        )}
      </StyledListWrapper>
      <StyledDivider color={Color.Gray200} />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
  margin-top: 16px;
`;

const StyledListWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  font-weight: ${FontWeight.Regular};
`;

const StyledListItem = styled.div(
  ({ isActive = false }: { isActive?: boolean }) => css`
    height: 100%;
    margin-right: 24px;
    padding: 16px 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    text-align: center;
    color: ${Color.Black};
    ${Typography.XSmall}

    ${isActive &&
    css`
      font-weight: ${FontWeight.Bold};
      padding: 16px 0 13px 0;
      border-bottom: 3px solid ${Color.Black};
    `}
  `,
);

const StyledDivider = styled(Divider)`
  width: 100%;
  bottom: 0;

  @media (${isPC}) {
    left: 0;
  }
`;
